import React from "react";
import AssignmentsPage from "./pages/AssignmentsPage";

export const assignmentRoutes = [
  { path: "/assignments", element: <AssignmentsPage /> },
];
